<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Reformer</h2>
        <h3>Our Faithful Reproduction of Joe’s Original Reformer</h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="Reformer_Contrology_Video_Thumb@1x.jpg"
              src2="Reformer_Contrology_Video_Thumb@2x.jpg"
              alt="Photo of Contrology Reformer and accessories"
              video
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-ref1@1x.jpg"
              src2="contrology-ref1@2x.jpg"
              alt="Photo of Contrology Reformer and accessories"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-ref2@1x.jpg"
              src2="contrology-ref2@2x.jpg"
              alt="Detail photo of head rest and leather straps"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-ref3@1x.jpg"
              src2="contrology-ref3@2x.jpg"
              alt="Detail photo of springs"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-ref4@1x.jpg"
              src2="contrology-ref4@2x.jpg"
              alt="Photo of foot being adjusted"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-ref5@1x.jpg"
              src2="contrology-ref5@2x.jpg"
              alt="Photo of Contrology branding on Reformer"
            />
            <!-- <photo
              @setFeature="setFeatureImg"
              src="contrology-ref6@1x.jpg"
              src2="contrology-ref6@2x.jpg"
              alt="Photo of man on Contrology Reformer"
            /> -->
          </photo-grid>

          <cta-button class="cta-button wide" />

          <div class="notice-wide">
            <p><b>Pre-Drill Tower Option</b></p>
            <p>
              If you know you want to add the Tower at a later time, you can now order the Reformer with the Pre-Drill Tower Option.
            </p>
            <p>
              For a $75 upgrade, we pre-drill your Reformer and add TwistLock removable shoulder rests. This will make adding the Tower easier to install in the future, and ensure you can remove your shoulder rests when exercising on the Tower and Mat Conversion. To order, call us at 916-388-2838 or email us at <a href="mailto:info@pilates.com" class="content-link">info@pilates.com</a>.
            </p>
          </div>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Reformer</h2>
              <h3>Our Faithful Reproduction of Joe’s Original Reformer</h3>
              <p>
                We partnered with Jay Grimes to re-create all of the subtle functionality critical to the classical Pilates approach, and build the best version of the original Reformers in Pilates studios circa 1970.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>The JGRIMES Contrology Reformer—in the words of Jay Grimes—is “everything you need and NOT all that other stuff you don’t.” It ships with no modifications&hellip; just the way Jay likes it.</p>
                <p>If you want a different color, or padded footbar, take a look at the 80C, 86C, or 89C Contrology Apparatus.
                <!-- <p>
                  Please review <a href="https://s3.amazonaws.com/s3.pilates.com/resources/Contrology_WeightLimits_CapitalEquipment.pdf" class="content-link">equipment weight limits</a>. -->
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="12-day lead time"
            />

            <p class="post-note">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >10-Year Warranty</icon-link>
              <icon-link
                url="support-reformer"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large
              v-if="showCardModal"
              @close="showCardModal=false"
            >
              Black only for JGRIMES Model
            </modal-card-large>

            <cta-button class="cta-button" />
            
            <div class="notice">
              <p><b>Pre-Drill Tower Option</b></p>
              <p>
                If you know you want to add the Tower at a later time, you can now order the Reformer with the Pre-Drill Tower Option.
              </p>
              <p>
                For a $75 upgrade, we pre-drill your Reformer and add TwistLock removable shoulder rests. This will make adding the Tower easier to install in the future, and ensure you can remove your shoulder rests when exercising on the Tower and Mat Conversion. To order, call us at 916-388-2838 or email us at <a href="mailto:info@pilates.com" class="content-link">info@pilates.com</a>.
              </p>
            </div>
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Choice of 4 models: 80” (203cm) JGRIMES, 80” (203cm) made-to-order, 86” (218cm) made-to-order, 89” (226cm) made-to-order</li>
              <li>Ultra strong and durable extruded aluminum frame</li>
              <li>One piece weld-free side rails are more stable for better ride,  and cleaner looking (no crevices to trap dirt)</li>
              <li>Thin, dense, resilient foam on carriage for maximum “feel”</li>
              <li>Weld-free cast aluminum shoulder supports with greater structural integrity and smooth radiused corners</li>
              <li>Lower angle footbar position provides increased feedback while exercising</li>
              <li>Deeper Springbar hooks provide proper spring angle</li>
              <li>Made-to-order headrest block maintains position (specially requested by Jay!)</li>
              <li>Contoured padded shoulder blocks for better fit</li>
              <li>Unpadded area around shoulder blocks creates space for feet to feel carriage base</li>
              <li>Specially developed Reformer Springs provide the authentic “muddy” feel and unique sound reminiscent of Joe’s original Reformers</li>
              <li>Pre-stretched and treated natural leather straps with O-rings and strap mounts for small adjustments in strap length</li>
              <li>NOTE: 80" JGRIMES Reformer does not support Jumpboard. If you want to add a Jumpboard, please order 86" or 89" Reformer.</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Included" animation="reveal">
            <ul class="included">
              <li>2 leather and wood handles</li>
              <li>36”/92cm Maple pole</li>
              <li>1 gear block</li>
              <li>2 cushioning kneeling pads</li>
              <li><router-link to="/contrology-box">Upholstered Box</router-link></li>
              <li>2 black cotton, footstraps</li>
              <li>2 black cotton, extender straps</li>
              <li>Choice of Upholstery Colors (JGRIMES: black only)</li>
              <li>Integrated Jumpboard brackets (86” and 89” Reformers only)</li>
              <li>2 carriage blocks (86” and 89” Reformers only)</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <dimensions-table-ref />
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Choice of 4 models: 80” (203cm) JGRIMES, 80” (203cm) made-to-order, 86” (218cm) made-to-order, 89” (226cm) made-to-order</li>
                <li>Ultra strong and durable extruded aluminum frame</li>
                <li>One piece weld-free side rails are more stable for better ride,  and cleaner looking (no crevices to trap dirt)</li>
                <li>Thin, dense, resilient foam on carriage for maximum “feel”</li>
                <li>Weld-free cast aluminum shoulder supports with greater structural integrity and smooth radiused corners</li>
                <li>Lower angle footbar position provides increased feedback while exercising</li>
                <li>Deeper Springbar hooks provide proper spring angle</li>
                <li>Made-to-order headrest block maintains position (specially requested by Jay!)</li>
                <li>Contoured padded shoulder blocks for better fit</li>
                <li>Unpadded area around shoulder blocks creates space for feet to feel carriage base</li>
                <li>Specially developed Reformer Springs provide the authentic “muddy” feel and unique sound reminiscent of Joe’s original Reformers</li>
                <li>Pre-stretched and treated natural leather straps with O-rings and strap mounts for small adjustments in strap length</li>
                <li>NOTE: 80" JGRIMES Reformer does not support Jumpboard. If you want to add a Jumpboard, please order 86" or 89" Reformer.</li>
              </ul>
            </tab>
            <tab name="Included">
              <ul class="included">
                <li>2 leather and wood handles</li>
                <li>36”/92cm Maple pole</li>
                <li>1 gear block</li>
                <li>2 cushioning kneeling pads</li>
                <li><router-link to="/contrology-box">Upholstered Box</router-link></li>
                <li>2 black cotton, footstraps</li>
                <li>2 black cotton, extender straps</li>
                <li>Choice of Upholstery Colors (JGRIMES: black only)</li>
                <li>Integrated Jumpboard brackets (86” and 89” Reformers only)</li>
                <li>2 carriage blocks (86” and 89” Reformers only)</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="table">
              <p class="cta">
                <strong>Compare Model Dimensions</strong>
              </p>
              <table>
                <thead>
                  <tr>
                    <th>Reformer</th>
                    <th>Reformer Length</th>
                    <th>Frame Width</th>
                    <th>Frame Height</th>
                    <th>
                      Reformer
                      <br />Weight
                    </th>
                    <th>
                      Carriage
                      <br />Dimensions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>JGRIMES Contrology 80&rdquo;</td>
                    <td>81”/206cm</td>
                    <td>27”/69cm</td>
                    <td>14”/36cm</td>
                    <td>114lbs/51.7kg</td>
                    <td>22"/56cm by <br />
                      36”/91cm
                    </td>
                  </tr>
                  <tr>
                    <td>Contrology 80&rdquo;</td>
                    <td>81”/206cm</td>
                    <td>27”/69cm</td>
                    <td>14”/36cm</td>
                    <td>114lbs/51.7kg</td>
                    <td>22"/56cm by <br />
                      36”/91cm
                    </td>
                  </tr>
                  <tr>
                    <td>Contrology 86&rdquo;</td>
                    <td>87”/221cm</td>
                    <td>27”/69cm</td>
                    <td>14”/36cm</td>
                    <td>117lbs/53kg</td>
                    <td>22"/56cm by <br />
                      36”/91cm
                    </td>
                  </tr>
                  <tr>
                    <td>Contrology 89&rdquo;</td>
                    <td>90”/229cm</td>
                    <td>27”/69cm</td>
                    <td>14”/36cm</td>
                    <td>118.5lbs/53.8kg</td>
                    <td>22"/56cm by <br />
                      36”/91cm
                    </td>
                  </tr>
                </tbody>
              </table>
              <span style="display:inline-block;margin-top:5px;">
                <em>*JGRIMES Reformer offers no customization or accessory options.</em>
              </span>
            </tab>
          </tabs>
        </section>
      </div>

      <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for Contrology Reformer</h2>
      </section>

       <section class="carousel">
        <div class="carousel-wrapper">
          <Carousel
            :perPage="3"
            :perPageCustom="[[0,1],[425,2],[700,3]]"
            :navigationEnabled="true"
            paginationActiveColor="#ffffff"
            paginationColor="#878787"
            :paginationSize="7"
            :navigationNextLabel="nextIcon"
            :navigationPrevLabel="prevIcon"
          >
            <slide>
              <accessory-card
                url="reformer-flash-cards"
                product="Reformer"
                src="contrology_reformerflashcards_teaser01@1x.jpg"
                src2="contrology_reformerflashcards_teaser01@2x.jpg"
                alt="Reformer Flashcards product photo"
                caption="Reformer Flashcards"
              />
            </slide>
            <slide>
              <accessory-card
                url="footbar-cover"
                product="Reformer"
                src="ref-footbar1@1x.jpg"
                src2="ref-footbar1@2x.jpg"
                alt="Footbar product photo"
                caption="Footbar Cover"
              />
            </slide>
            <slide>
              <accessory-card
                url="jumpboard"
                product="Reformer"
                src="ref-jumpboard1@1x.jpg"
                src2="ref-jumpboard1@2x.jpg"
                alt="Jumpboard product photo"
                caption="Jumpboard"
                captionSmall='not available for 80" Reformer'
              />
            </slide>
            <slide>
              <accessory-card
                url="springs"
                product="Reformer"
                src="ref-springs1@1x.jpg"
                src2="ref-springs1@2x.jpg"
                alt="Springs product photo"
                caption="Springs"
              />
            </slide>
            <!-- <slide>
              <accessory-card
                url="new-york-reformer-springs"
                product="Reformer"
                src="krn-springs2@1x.jpg"
                src2="krn-springs2@2x.jpg"
                alt="New York Pilates springs product photo"
                caption="New York Pilates Springs"
              />
            </slide> -->
          </Carousel>
        </div>
      </section>

      <testimonial
        src="quotebanner-reformer@1x.jpg"
        src2="quotebanner-reformer@2x.jpg"
        alt="Photo of Jay Grimes working with student on a Contrology Reformer"
      >
        “It was so much fun to work with Balanced Body on the Contrology Reformer…. to be able to really look at how (it) works, how we use it as practitioners, what needs to happen, and what was missing. I’m just very happy that we finally have it.”
        <span>~Jay Grimes</span>
      </testimonial>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/uiaN-oDV4yw?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import DimensionsTableRef from "@/components/DimensionsTableRef.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";
import Testimonial from "@/components/Testimonial.vue";
import { Carousel, Slide } from 'vue-carousel';
import Modal from "@/components/Modal.vue";

export default {
  name: "reformer",

  metaInfo: {
    title: "Classical Pilates Reformer - Contrology Reformer",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "This Classical Pilates Reformer was designed with Jay Grimes to be a faithful reproduction of Joe's Original Reformer. Check out our Contrology Reformer now."
      },
      {
        property: "og:image",
        content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-ref1@1x.jpg"
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaButton,
    ProdAccordion,
    DimensionsTableRef,
    Tabs,
    Tab,
    AccessoryCard,
    Testimonial,
    Carousel,
    Slide,
    Modal
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Reformer",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41265568121025,
          partnumber: 16095,
          price: 4800,
          name: "JGRIMES Model",
          available: true
        },
        {
          prodid: "na",
          partnumber: "16472C",
          // price: "4800 *",
          price: "Call for pricing *",
          name: '80" Made-To-Order Model',
          available: false
        },
        {
          prodid: "na",
          partnumber: "16472C",
          // price: "5185 *",
          price: "Call for pricing *",
          name: '86" Made-To-Order Model',
          available: false
        },
        {
          prodid: "na",
          partnumber: "16472C",
          // price: "5185 *",
          price: "Call for pricing *",
          name: '89" Made-To-Order Model',
          available: false
        }
      ]
    };
  },

  computed: {
    nextIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.51922 0.624325C1.21151 -0.208109 2.33394 -0.208109 3.02623 0.624325L12.4808 11.9927C13.1731 12.8252 13.1731 14.1748 12.4808 15.0073L3.02624 26.3757C2.33395 27.2081 1.21152 27.2081 0.519224 26.3757C-0.173069 25.5432 -0.173069 24.1936 0.519224 23.3612L8.72026 13.5L0.51922 3.63883C-0.173073 2.8064 -0.173073 1.45676 0.51922 0.624325Z" fill="black"/>
</svg>`;
    },

    prevIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4808 26.3757C11.7885 27.2081 10.6661 27.2081 9.97377 26.3757L0.519221 15.0073C-0.173073 14.1748 -0.173073 12.8252 0.519222 11.9927L9.97377 0.624325C10.6661 -0.208107 11.7885 -0.208107 12.4808 0.624325C13.1731 1.45676 13.1731 2.8064 12.4808 3.63884L4.27974 13.5L12.4808 23.3612C13.1731 24.1936 13.1731 25.5432 12.4808 26.3757Z" fill="black"/>
</svg>`;
    }
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

.notice {
  border: 1px solid #000000;
  padding: 0 10px;
  margin-bottom: 30px;
}

.notice-wide {
  display: none;
}

.post-note {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

::v-deep .VueCarousel {
  max-width: 900px;
  margin: 0 auto;
}

::v-deep .VueCarousel-dot-container {
  display: block;
  margin-top: 0 !important;
  padding: 0;
  text-align: right;
}

::v-deep .VueCarousel-dot {
  margin-top: 0 !important;
  padding: 0 7px !important;
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none;
}

::v-deep .VueCarousel-navigation-prev {
  left: 4px;
}

::v-deep .VueCarousel-navigation-next {
  right: 4px;
}

::v-deep .VueCarousel-navigation--disabled {
  opacity: 0.3;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 160%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .table {
    max-width: 650px;
    margin: 0 auto;
  }

  .table table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .table th,
  .table td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .table td {
    height: 50px;
  }

  .table tr th:first-of-type,
  .table tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .notice {
    order: 4;
    margin-bottom: 0;
    margin-top: 10px;
  }

  .links {
    column-count: 1;
    order: 5;
  }

  ::v-deep .modal-card-wrapper {
    top: 100%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 100px 120px auto;
    position: relative;
    z-index: 1;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    max-width: 512px;
  }

  .cta-button,
  .notice {
    display: none;
  }

  .notice-wide {
    display: block;
    border: 1px solid #000000;
    padding: 0 10px;
    margin: 0 32px;
    height: 240px;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
